// NOTIFY-001 SMS Service (owner, 2026-10-23; D-052): the shop's SMS page (credits, order messages,
// bulk SMS, purchases, usage) and the owner console's SMS section. Our own wording.
export const smsServiceStrings = {
  status: {
    off: "SMS isn't connected yet",
    offBody:
      "Adyvance is connecting its Aakash SMS account. Until then nothing is texted and no credits are used: order messages wait in the usage log.",
    on: "Sending through {provider}",
  },
  providers: { aakash: "Aakash SMS", ntc: "Nepal Telecom", sparrow: "Sparrow SMS" },
  credits: {
    title: "SMS credits",
    left: "SMS left",
    of: "of {total}",
    used: "{count} used",
    buy: "Buy SMS",
    hint: "1 credit sends 1 SMS: 160 English letters, or 70 with Nepali or emoji.",
    pending: "{count} waiting for confirmation",
    plan: "Plan: {left} of {limit} free SMS left this month",
    planUnlimited: "Plan: unlimited SMS this month",
    planNote: "Your plan's free SMS go first, then bought credits.",
  },
  vars: {
    title: "Message variables",
    lead: "Use these in order messages. Each one is filled in for every customer.",
    note: "Bulk SMS goes exactly as you write it: variables only work in order messages.",
    copied: "Copied {name}",
    items: {
      store_name: "Your store name",
      customer_name: "The customer's name",
      order_number: "The order number",
      order_total: "The order total",
      amount_due: "Amount to collect on delivery",
      track_url: "Order tracking link",
      payment_method: "How the customer pays",
    },
  },
  tabs: {
    events: "Order messages",
    bulk: "Bulk SMS",
    purchases: "Purchases",
    usage: "Usage",
  },
  events: {
    event: "When",
    on: "On",
    message: "Message",
    sent: "Sent",
    length: "Length",
    parts: "{count} SMS",
    edit: "Edit message",
    turnedOn: "{event} SMS is on",
    turnedOff: "{event} SMS is off",
    names: {
      created: "Order received",
      confirmed: "Order confirmed",
      shipped: "Order dispatched",
      delivered: "Order delivered",
      cancelled: "Order cancelled",
    },
    hints: {
      created: "As soon as a customer places an order",
      confirmed: "When you confirm the order",
      shipped: "When the parcel leaves with the courier",
      delivered: "When the order is delivered and paid, with a link to review it",
      cancelled: "When the order is cancelled",
    },
  },
  edit: {
    title: "{event} SMS",
    lead: "Click a variable to add it where the cursor is.",
    message: "Message",
    preview: "Preview",
    count: "{chars} characters · {parts} SMS",
    unicode: "Nepali or emoji: 70 letters per SMS",
    reset: "Use the default text",
    save: "Save message",
    saved: "Message saved",
    cancel: "Cancel",
    sample: {
      store_name: "Himal Threads",
      customer_name: "Sita",
      order_number: "1024",
      order_total: "Rs 2,450",
      amount_due: "Rs 2,450",
      track_url: "himal.np/track/aB3x",
      payment_method: "COD",
    },
  },
  bulk: {
    to: "Send to",
    groups: "Customers",
    paste: "Phone numbers",
    groupNames: {
      all: "All customers",
      repeat: "Repeat buyers",
      vip: "VIP customers",
      one_time: "One-time buyers",
    },
    groupHints: {
      all: "Everyone with a mobile number",
      repeat: "2 or more orders",
      vip: "5 or more orders",
      one_time: "Exactly 1 order",
    },
    mobiles: "{count} mobiles",
    mobilesLabel: "mobiles",
    numbersPh: "98XXXXXXXX, one per line or separated by commas",
    numbersCount: "{valid} valid · {invalid} not valid",
    message: "Message",
    messagePh: "Dashain offer: 20% off everything this week. Shop now at himal.np",
    ideas: {
      flash: "Flash sale",
      coupon: "Coupon",
      festival: "Festival offer",
      arrivals: "New arrivals",
    },
    ideaText: {
      flash: "Flash sale today only! Up to 30% off at {store}. Hurry, while stock lasts.",
      coupon: "Thank you for shopping with {store}! Use code SAVE10 for 10% off your next order.",
      festival: "Happy Dashain from {store}! Enjoy 20% off everything this week.",
      arrivals: "New arrivals are in at {store}. Come and see what's new!",
    },
    summary: {
      recipients: "Recipients",
      parts: "SMS each",
      credits: "Credits needed",
      balance: "Your balance",
      plan: "Free with your plan",
      skipped: "Skipped",
    },
    skippedHint: "Numbers that aren't valid Nepal mobiles, repeats, and people who opted out.",
    quiet: "Offers can't go out between 8 pm and 8 am (Nepal time). Send after 8 am.",
    short: "You need {count} more credits.",
    send: "Send SMS",
    confirmTitle: "Send this SMS to {count} people?",
    confirmBody: "It uses {credits} credits. This can't be undone.",
    confirm: "Send now",
    sentOk: "SMS is on its way to {count} people.",
    blocked: "Saved, not sent: SMS isn't connected yet. No credits were used.",
    history: "Bulk SMS history",
    empty: "No bulk SMS yet. Your sends show here.",
    states: {
      sending: "Sending",
      sent: "Sent",
      blocked: "Not sent: SMS not connected",
    },
    sourceGroup: "{group}",
    sourceNumbers: "{count} pasted numbers",
    sourceOrders: "{count} orders",
    people: "{count} people",
  },
  buy: {
    title: "Buy SMS credits",
    lead: "Pay Adyvance, upload the receipt, and the credits are added as soon as we confirm it.",
    leadWallet: "Paid from your Adyvance Wallet. The credits are added at once.",
    walletNote:
      "SMS credits are paid from your Adyvance Wallet. Short of money? Top up from the payment box and come back.",
    paid: "SMS credits added",
    packs: "Choose a pack",
    perSms: "Rs {price} per SMS",
    best: "Best value",
    unit: "SMS",
    noPacks: "Adyvance hasn't added SMS packs yet.",
    pay: "How you pay",
    methods: {
      wallet: "Adyvance Wallet",
      qr: "QR",
      bank: "Bank transfer",
      esewa: "eSewa",
      khalti: "Khalti",
    },
    soon: "Soon",
    scan: "Scan to pay {amount}",
    noQr: "Adyvance hasn't added its QR yet. Use bank transfer.",
    bank: { bank: "Bank", name: "Account name", number: "Account number" },
    noBank: "Adyvance hasn't added its bank details yet.",
    reference: "Transaction ID",
    referencePh: "From your payment app or bank",
    receipt: "Receipt",
    upload: "Upload receipt",
    change: "Change",
    uploading: "Uploading…",
    total: "Total",
    credits: "Credits",
    submit: "Send for confirmation",
    sent: "Purchase sent. The credits are added when Adyvance confirms your payment.",
    need: "Add the receipt or the transaction ID.",
    close: "Close",
  },
  purchases: {
    date: "Date",
    credits: "Credits",
    amount: "Amount",
    method: "Paid by",
    reference: "Reference",
    status: "Status",
    empty: "No purchases yet. Buy SMS credits to start sending.",
    states: {
      submitted: "Waiting for confirmation",
      confirmed: "Credits added",
      rejected: "Rejected",
    },
    ledger: "Credit history",
    kinds: { purchase: "Bought", grant: "From Adyvance", debit: "Sent", refund: "Given back" },
  },
  usage: {
    date: "Date",
    type: "Type",
    to: "To",
    parts: "SMS",
    credits: "Credits",
    status: "Status",
    empty: "No SMS yet. Order messages and bulk SMS show here.",
    bulk: "Bulk SMS",
    states: {
      queued: "Waiting (not connected)",
      sent: "Sent",
      delivered: "Delivered",
      failed: "Failed",
      suppressed: "Skipped (opted out)",
    },
    errors: { no_credits: "No credits left" },
  },
  errors: {
    credits: "Not enough SMS credits. Buy more and send again.",
    quiet: "Offers can't go out between 8 pm and 8 am. Send after 8 am.",
    online: "Paying by eSewa or Khalti isn't available yet. Pay by QR or bank transfer.",
    variable: "The message uses a variable that doesn't exist.",
    nobody: "There's no valid mobile number to send to.",
  },
  console: {
    title: "SMS Service",
    lead: "SMS credit purchases from shops, their balances, and your packs and payment details.",
    tiles: {
      toConfirm: "Purchases to confirm",
      shops: "Shops with credits",
      credits: "Credits with shops",
      provider: "SMS provider",
      providerOff: "Aakash SMS not connected",
      providerLeft: "{provider}: {count} SMS left",
      providerLow:
        "Shops hold more credits than Adyvance has left at {provider}. Top up the provider.",
      providerError: "{provider}: balance unavailable",
    },
    tabs: { purchases: "Purchases", balances: "Balances", packs: "Packs", pay: "How shops pay" },
    open: "Waiting",
    all: "All",
    shop: "Shop",
    receipt: "View receipt",
    noReceipt: "No receipt",
    confirm: "Confirm and add credits",
    reject: "Reject",
    note: "Note (optional)",
    decided: "Purchase updated",
    emptyPurchases: "No purchases yet.",
    emptyBalances: "No shop has SMS credits yet.",
    adjust: "Add or take credits",
    adjustTitle: "Credits for {shop}",
    adjustCredits: "Credits (use minus to take)",
    adjustNote: "Reason",
    adjustSave: "Save",
    adjusted: "Credits updated",
    balance: "Balance",
    purchased: "Ever added",
    used: "Used",
    packsLead: "The packs shops can buy. Price is the total for the pack.",
    packCredits: "Credits",
    packPrice: "Price (Rs)",
    packActive: "On sale",
    addPack: "Add pack",
    savePacks: "Save packs",
    packsSaved: "Packs saved",
    perSms: "Rs {price} per SMS",
    remove: "Remove",
  },
} as const;
